<template>
  <b-card title="Долги модерации" class="h-100">
    <div v-for="item in items" :key="item.label" class="d-flex justify-content-between align-items-center py-50 border-bottom font-small-3">
      <b-link v-if="item.route" :to="item.route">{{ item.label }}</b-link>
      <span v-else>{{ item.label }}</span>
      <b-badge :variant="item.value > 0 ? `light-${item.variant}` : 'light-secondary'">{{ formatNumber(item.value) }}</b-badge>
    </div>
  </b-card>
</template>

<script>
import { BCard, BBadge, BLink } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatNumber } from '@/views/dashboard/sifnf/utils'

export default {
  components: { BCard, BBadge, BLink },
  props: {
    debts: { type: Object, default: null },
    generator: { type: Object, default: null },
  },
  setup(props) {
    const items = computed(() => {
      const debts = props.debts || {}
      const generator = props.generator || {}
      return [
        { label: 'Треки без файлов', value: debts.tracks_missing, variant: 'warning', route: { name: 'tracks-missing' } },
        { label: 'Треки без артиста', value: debts.tracks_orphans, variant: 'warning', route: { name: 'tracks-orphans' } },
        { label: 'Артисты без кластера', value: debts.artists_without_cluster, variant: 'danger', route: { name: 'artists', query: { has_cluster: '0' } } },
        { label: 'Артисты без сложности', value: debts.artists_without_difficulty, variant: 'warning', route: { name: 'artists', query: { has_any_difficulty: '0' } } },
        { label: 'Артисты без страны', value: debts.artists_without_country, variant: 'secondary', route: { name: 'artists', query: { has_country: '0' } } },
        { label: 'Списки без автотопика', value: debts.lists_free, variant: 'info', route: { name: 'lists' } },
        { label: 'Пустые автотопики', value: debts.autotopics_empty, variant: 'info', route: { name: 'autotopics' } },
        { label: 'Пакеты генератора с ошибками', value: generator.with_errors, variant: 'danger', route: { name: 'generator-packs' } },
        { label: 'Пакеты генератора в процессе', value: generator.in_progress, variant: 'primary', route: { name: 'generator-packs' } },
      ]
    })
    return { items, formatNumber }
  },
}
</script>
